module.exports = __webpack_public_path__ + "img/success-booking-illustration.18af18bf.svg";